import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HeadsetOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"headset_off"}/>
}
